var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:['bx--navigation__category-item', { 'bx--navigation-item--active': _vm.active }]},[_c('a',{staticClass:"bx--navigation-link",staticStyle:{"cursor":"pointer"},on:{"click":_vm.go}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }